import {
  CreateInviteLinkMutation,
  CreateInviteLinkMutationVariables,
  DestroyInviteLinksMutation,
  DestroyInviteLinksMutationVariables,
  DestroySubAccountMutation,
  DestroySubAccountMutationVariables,
  GetSubAccountsQuery,
  GetSubAccountsQueryVariables,
  UpdateSubAccountMutation,
  UpdateSubAccountMutationVariables,
  UserRole,
  UserStatus,
} from '@/typings/domain'
import apolloClient from './apolloClient'
import CreateInviteLinkGQL from './graphql/CreateInviteLink.graphql'
import DestroyInviteLinksGQL from './graphql/DestroyInviteLinks.graphql'
import DestroySubAccountGQL from './graphql/DestroySubAccount.graphql'
import GetSubAccountsGQL from './graphql/GetSubAccounts.graphql'
import UpdateSubAccountGQL from './graphql/UpdateSubAccount.graphql'

export function getSubAccounts(variables: GetSubAccountsQueryVariables) {
  return apolloClient.query<GetSubAccountsQuery, GetSubAccountsQueryVariables>({
    query: GetSubAccountsGQL,
    variables,
    fetchPolicy: 'no-cache',
  })
}

type UpdateSubAccountInput = {
  id: string
  role?: UserRole
  status?: UserStatus
  name?: string
}
export function updateSubAccount({ id, role, status, name }: UpdateSubAccountInput) {
  return apolloClient.mutate<UpdateSubAccountMutation, UpdateSubAccountMutationVariables>({
    mutation: UpdateSubAccountGQL,
    variables: { input: { id, attributes: { role, status, name } } },
    fetchPolicy: 'no-cache',
  })
}

export function destroySubAccount({ id }: { id: string }) {
  return apolloClient.mutate<DestroySubAccountMutation, DestroySubAccountMutationVariables>({
    mutation: DestroySubAccountGQL,
    variables: { input: { id } },
    fetchPolicy: 'no-cache',
  })
}

export function destroyInviteLinks() {
  return apolloClient.mutate<DestroyInviteLinksMutation, DestroyInviteLinksMutationVariables>({
    mutation: DestroyInviteLinksGQL,
    fetchPolicy: 'no-cache',
  })
}

export function createInviteLink({ role }: { role: UserRole }) {
  return apolloClient.mutate<CreateInviteLinkMutation, CreateInviteLinkMutationVariables>({
    mutation: CreateInviteLinkGQL,
    variables: { input: { role } },
    fetchPolicy: 'no-cache',
  })
}
